// extracted by mini-css-extract-plugin
export var splash = "splash-module--splash--gzM7D";
export var splash__anim = "splash-module--splash__anim--kQqFC";
export var splash__clubs = "splash-module--splash__clubs--D5n1A";
export var splash__clubs__logo = "splash-module--splash__clubs__logo--KYiFW";
export var splash__clubs__name = "splash-module--splash__clubs__name--hZekV";
export var splash__clubs__names = "splash-module--splash__clubs__names--0LRJv";
export var splash__clubs__vs = "splash-module--splash__clubs__vs--lum7P";
export var splash__content = "splash-module--splash__content--nhCZF";
export var splash__count = "splash-module--splash__count--EYYiL";
export var splash__count__colon = "splash-module--splash__count__colon--j3yDN";
export var splash__count__completed = "splash-module--splash__count__completed--wFB5e";
export var splash__count__info = "splash-module--splash__count__info--mL3JI";
export var splash__count__item = "splash-module--splash__count__item--qOCad";
export var splash__count__number = "splash-module--splash__count__number--W9NdX";
export var splash__count__wrapper = "splash-module--splash__count__wrapper--6kOxy";
export var splash__date = "splash-module--splash__date--oBjBk";
export var splash__date__top = "splash-module--splash__date__top--DRHuI";
export var splash__join = "splash-module--splash__join--hzi2U";
export var splash__sponsor = "splash-module--splash__sponsor--eJzPh";